import {
  IntegrationSetupPage,
  IntegrationSetupPageProps,
} from "~/pages/integrations/IntegrationsSetup/IntegrationSetupPage";

const IntegrationSetupEntryPage = ({ scope }: IntegrationSetupPageProps) => {
  return <IntegrationSetupPage {...{ scope }} />;
};

export default IntegrationSetupEntryPage;
